
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 20 20"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"var(--brand-primary)","fill-rule":"evenodd","d":"M10.1 10.17H20q-.64 6.9-6.32 9.1t-10.74-2.2l3.53-3.4a6.27 6.27 0 003.63 1.42 4.72 4.72 0 003.17-1.3l-3.17-3.62zM0 9.92h5.07q.3-3.73 3.55-4.68A4.76 4.76 0 0114.1 7.2l3.96-3.23Q13.07-1.63 6.5.67.44 2.81 0 9.92z"}})])
          )
        }
      }
    